var _style, _desc, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteLogoCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 886 890",
    width: 886,
    height: 890,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0420\u043E\u0434\u044B \u0432 \u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0435 \u0441 \u041E\u043B\u044C\u0433\u043E\u0439") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: var(--rosa) } \r\n\t\t.s1 { fill: none } \r\n\t")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\u0420\u043E\u0434\u044B \u0432 \u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0435 \u0441 \u041E\u043B\u044C\u0433\u043E\u0439")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m480.6 327.5c-7.4 1.8-16.1 3.2-23.9 0.5-2.9-1-5.7-2.2-7.5-5-1.9-2.7-1.6-6-1.6-9 0-9.9 1.1-20.1 6.3-28.9 10.9-18.4 36.6-20.7 44.7 1.2 2.4 6.4 2.3 13.1 1.9 19.6-0.4 4.6-0.8 9.9-3.4 14.1-1 1.4-2.2 2.6-3.6 3.3l-0.4-0.4c4.8-4.1 4.4-11.1 4.1-16.9-0.3-8.9-1.2-18.8-8-25.2-6.9-6.6-17.5-5.3-24.4 0.6-10.8 9-12.3 24.3-12.6 37.5 0.6 4.4 6.5 6.1 10.2 7.1 5.9 1.5 12.1 1.2 18.2 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m451 321.8c1.8 1.5 2.4 4.6 4.2 5.9 0.4 0.1 0.5-0.1 0.6-0.3 0.1-0.2 1.5 0.1 2.1 0 8.3 0 16.6-0.6 24.7 3.3l0.1 0.6c-6.5 0.9-13.2 1.9-19.7 2.1-3.3-0.1-6.9-0.2-9.9-2-3.1-2.1-2-6.4-2.7-9.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m490 278.9c-0.9-2.2-2.4-4-3-6.3-1.5-4.9 2.6-8.9 7.2-9.7 5.7-1.5 12.4-1.5 17.7 1.5 1.7 0.7 2.9 2.2 3.6 3.8 0.8 1.8 1.3 3.5 1.8 5.2 0.5 0.9 1.5 3.8 1.3 5.7-0.1 1.5-0.5 2.7-0.9 3.7-2.8 5.5-2.4 12.6-8 16.6-3 2.3-8.2 2.4-10-1.2l0.5-0.5c1.9 2 5.5 1.3 7.3-0.6 3-3.1 2.9-7.9 3.6-12 0.3-2.7 2.5-5.4 1.3-8.1-1.1-2.2-1.5-4.8-2.6-6.9-3.7-2.7-8.5-3.2-13-2.8-2.5 0.1-6.1 0.2-6.9 3.1-0.7 2.7 0.8 5.6 0.7 8.5 0 0-0.6 0-0.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m512.7 292.7c3.9 2.5 7.2 5.3 11.4 6.4 2.1 0.4 3.3-0.2 5-1.4 4.3-3.5 4.5-10.5 4.6-15.6-0.2-3-3.4-3.8-6.1-4.7-2.7-0.7-5.6-1.6-8.3-1.6-1.4 0.1-2.7 0.4-3.8 1.5l-0.5-0.3c2.6-5.4 12.9-4.1 17.7-2.8 5.5 1.6 7.2 6.2 6.8 11.5 0 7.7-3.5 17.4-12.4 18.1-6.6 0.2-11.2-5.9-14.9-10.7 0 0 0.5-0.4 0.5-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m512.8 292.9c3.4 2.8 4.3 6.5 3.9 10.2-0.6 3.7-2.2 5.2-4.8 8.7l-0.5 0.1c-2-5.4-0.2-11.2 0.5-16.7q0.2-1.2 0.3-2.3h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m502.4 313.4c11-6.4 25.8-1 32.8 8.9 2.4 3.4 4 7.3 4 11.6l-0.5 0.3-1.5-2.3c-0.8-1.1-2.5-3.2-3.4-4.2-7.4-7.9-17.8-12.9-28.7-13.6l-2.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m541.7 325.4c4.7-1.8 10.6 0.9 12 5.7 0.6 1.8 0.4 3.1 0.9 5.2l-0.1 0.6c-3-0.7-5-3.1-7.1-5l-3-3.1c-0.9-1-1.9-2-3-2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m536.1 295.9c6.2 8 3.7 18-3.2 24.7h-0.6c-0.1-2.1-0.1-4.2 0.2-6.3 0.4-3.6 1.4-8.7 2-12.3l1.1-6.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m536.1 295.9c1.1 4.4 2.5 8.4 3.8 12.7 0.2 0.5 0.5 1.7 0.8 2.1 0.2 0.4 0.2 0.3 0.5 0.3 3.3 0.8 8.4 2.6 11.3 0.3 4.4-4.3 1.7-10.8-2.5-14.7-2-1.7-4.1-3.9-6.7-4.6-2.7-0.6-5.9 1.3-7.2 3.9l-0.6-0.1c0.5-3.6 3.8-6.6 7.5-7 1.9-0.2 3.7 0.4 5.3 1.2 4.8 2.4 9.2 6 11.3 11.1 2.2 5 1 11.6-3.5 15-3.1 2.3-7.1 2.2-10.6 1.3-5.1-1.4-9-2.1-9.3-8.3-0.5-4.4-1.1-8.8-0.7-13.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m559.9 302.8c4.6 10.4 5 21.2 3.5 32.2-0.6 3.6-1.4 7.1-3 11l-0.6 0.1c-1.7-10.8-1.8-21.7-1.4-32.6 0.2-3.6 0.5-7.2 0.9-10.8 0 0 0.6 0.1 0.6 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m562 346.3c1.2 0.8 2.1 0.6 3.1 0.7 0.9 0 1.7 0 2.8 0.3 6.5 1.8 11.2 6.6 12.4 13.6l-0.4 0.5q-2.5-1.6-5-3.3-5-3.3-9.8-6.9c-1.6-1.2-3.6-2.6-3.7-4.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m562 347.7c-2.5-1.3 0.4-5.1 1.1-6.7 0.3-0.5 0.6-0.9 0.6-1.4l1.4-6.3 2.9 7c0.9 2.1 3.2 3.4 5.5 3.6 2.5 0.3 5.9-0.2 8.4-0.7 0.5-0.1 0.7-0.3 0.8-0.4 0.2-0.4 0.7-1 0.9-1.7 0.7-1.8 1-3.5 1.1-5.6 0.1-2.6 0.5-5-0.3-7.2-1.7-4-7-4.9-10.4-2.4-1 0.7-1.9 1.9-2.9 3.1-2.1 2.8-3.9 5.4-5.2 8.7l-0.6-0.1c0.2-3.5 1.6-6.8 3-9.9 1.5-3.2 3.9-6.2 7.3-7.4 5.1-2 11.3 0.4 13.8 5.3 2.9 5.2 1.7 19.1-4.1 22.1-2.4 1.2-5.2 1-7.8 1.1-5.1 0.1-11.6-2.4-12.1-8.3l0.8 0.2c-0.7 1.2-1.9 2.3-2.7 3.3-0.7 0.8-2.1 2.3-1.1 3.1 0 0.1-0.4 0.6-0.4 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m590.1 327.9c4 9.5 4 19.8-0.6 29-1.8 3.1-4.3 6.4-7.9 7.5l-0.4-0.4c0.9-1.2 1.7-2.6 2.2-4 0.4-1 0.8-2.3 1.1-3.3 1.8-6.4 2.6-13 3.5-19.6 0.3-2.7 0.8-6.6 1.5-9.3 0 0 0.6 0.1 0.6 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m581.7 364.1c9.6 15.5-2.5 36.8-17.3 44.2l-0.5-0.3 3.4-5c6.7-9.9 13.1-20.7 13.8-32.8q0.3-3 0-6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m451.7 327.2c4.8 12.6 4.9 26.3 3.4 39.4-0.1 0.6 0.1 0.8-0.1 0.3-0.1-0.3-0.3-0.6-0.6-1-0.3-0.2-0.4-0.3-0.2-0.2 2.5 1.7 5 3 8.2 3.6 2.5 0.5 5.3 0.6 8.3 0.6 3.2 0.1 6.4-0.1 9.6 0.5v0.6c-3 0.5-5.9 1.4-8.9 2.1-7.1 1.7-15.4 1.5-21.4-3.3-1.4-1.6-0.7-4.1-0.6-6 1-9.1 1.7-18.3 1.8-27.4q0.1-4.6-0.1-9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m435.4 565.9c0.7 2.5 2.3 4.7 3.8 6.9 2.5 3.3 5.2 7 8.8 9.1 7.7 2.9 16.6 5.8 24.6 4.8 7.3-0.8 13-5.5 17.5-11.2 4.9-6 9-12.7 13-19.6 10.4-18.1 21.9-36.8 26.4-57.4 2.6-10.2 4.1-20.9 6.1-31.6 1.7-10.9 4.8-22.7 12.4-31.4 2.8-3.4 7.5-8.9 9.8-12.7 3-4.4 4.2-9.7 6.1-14.7l0.6 0.1c-0.7 2.6-1.3 5.3-1.9 7.9-2.5 10.9-11.3 18.5-16.3 28.1-3.7 7.3-4.9 15.4-6.1 23.4-2.8 21.5-5.9 43.5-16.2 62.9-4.9 9.7-10.5 19-16.1 28.3-5.7 9.3-11.5 18.7-19.9 25.8-9 7.6-20.7 7.4-31.2 3.6-3.2-1.1-6.4-2.5-9.5-3.9-1.9-0.9-3.3-2.5-4.6-4.1-3.3-4.3-6.7-8.9-7.9-14.3 0 0 0.6 0 0.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m406.1 307c3.4 2.3 2.3 7.2 0.9 10-0.1 0.1 0.1-0.2 0.1-0.2 0.3-0.3 0.6-0.9 0.7 0 0 0.2 0 0.7 0.2 0.8 0.1-0.4-0.1-1-0.2-1.2l-0.1-0.5c2.5 2.7 4.2 5.9 6.9 8.4 0.9 0.9 2.1 1.6 3.3 2.2l0.2 0.6c-5.2 1.9-10.6-1.7-13.7-5.7-0.7-1.2-1.9-2.1-2.1-3.6 0-1.3 0.2-2.4 0.7-3.5 0.8-1.2 1.9-2.2 2.3-3.6 0.5-1 0.5-2.3 0.3-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m416.6 319.8c5.1-3.1 10.1-4.2 15.7-4.8 2.5-0.3 5 0 7.2-1 4.2-2.3 7.6-5.1 12.3-8l0.6 0.2c-2.7 5.7-8.1 13.7-14.8 14.4-3.1 0.2-7.4 0-10.5 0-2.6 0-7.9-0.1-10.5-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m406.5 310.9c-3.8-8.8-4.6-19-2.5-28.5 0-2.5-0.3-5.5 1-8.4 2.1-5.5 7.6-9.2 12.7-11.2 16.6-7.2 27.4 2.5 32.2 18.2 2.9 9.5 2.8 19.2 1.7 28.8l-0.6 0.1c-0.5-4.6-1.1-9.2-1.9-13.8-1.3-6.8-3.1-13.6-6.7-19.5-3.3-6-8.6-11.4-16-10.1-4.4 0.6-8.9 2.4-12.5 5-1.8 1.3-3.4 3-4.2 5.1-0.8 2-0.5 4.4-1 6.8-0.3 1.2-0.7 2.2-1 3.3-1.9 7.9-1.9 16.2-0.6 24.1 0 0-0.6 0.1-0.6 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m449.9 314.7c5.1 5 1.4 13.7-3 17.8-4.1 4.5-13.9 7.4-18.2 1.2l0.2-0.6c1.3 0.4 2.6 0.5 3.8 0.4 3.9-0.2 7.3-2.5 10-5.3 2.8-2.7 5.4-5.8 6.3-9.6 0.4-1.2 0.5-2.5 0.3-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m451 318.6c5.8 31.6 5.9 64.3-1.3 95.6-2.5 10.5-6 20.8-11.1 30.3l-0.5-0.1 2.1-7.7 1.8-7.7c5.7-25.8 7.4-52.4 8-78.7 0.2-9.2 0.3-22.3 0.4-31.7 0 0 0.6 0 0.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m400 591.2c5.2-0.4 10.6-1.1 15.4-2.9 1.5-0.6 2.9-1.4 4.1-2.3 7.9-6 10.2-16.7 12.2-26 2-10.3 3.4-20.8 4.8-31.3 1.7-12.1 2.9-24.1 2.3-36.3-0.6-16-4.4-32.4-0.7-48.3h0.6c-1.1 14.4 2.6 28.4 4.5 42.5 3.1 21.5-0.5 43-4.1 64.1-1.4 7.1-2.8 14.1-5.3 20.9-2.8 7.5-7.4 15.2-15.1 18.3-5.9 2.3-12.5 2.3-18.7 1.9 0 0 0-0.6 0-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m319.7 377c-4.1 2.6-8.3 3.7-11.7 6.3 0.5-0.2 1.3-1.1 1.5-1.6 0.1-0.4 0.2-1.1 0.1-1.5 0 0 0.1 0 0.1 0 0 0 0 0.1 0.1 0.1 0.5 0.7 1.1 1.6 1.5 2.4 5.1 8.9 1.9 19.5 4.7 28.9 0.8 3.3 2.1 6.7 3.5 10 4.1 10 9.7 20 21 22.7v0.6c-4 0.3-7.9-0.9-11.4-2.8-9.8-5.7-15.8-18.4-18.9-29-2.3-7.6-0.5-15.6-1.3-23.3-0.2-1.9-0.6-3.7-1.4-5.5-0.4-1.1-1.2-2.2-1.4-3.5-0.1-0.2 0.1-0.5 0.3-0.7 4.1-2.1 8.8-2.4 13.1-3.6 0 0 0.2 0.5 0.2 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m318.4 428.9c6.3 17 12.9 33.3 15.9 51.3 1.7 10.9 1.7 21.9-0.3 32.9h-0.6c-1.6-14.2-3.3-28.3-7.1-42.1-2.6-10.4-5.5-20.8-7.3-31.4-0.6-3.5-1-7.1-1.2-10.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m307.3 383.5c-2.8-1.5-4.5-3.8-5.7-6.1-3.4-7-2.8-13.4-0.4-20.9l0.5-0.2c2.2 4.1 3 8.9 3.7 13.4 0.6 4.6 1.1 9.2 2.5 13.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m301.6 358.1c-4.1-8.2-6.6-17.6-4.6-26.9 0.6-3.3 1.3-6.5 1.7-9.7 0.1-3.3 2.5-6.3 5.9-6.8 3.8-0.6 7.8-0.4 11.6 1.4 9.3 4.7 15.3 18.1 7.9 26.9-2.6 3-6.8 5.2-10.8 4.1v-0.6c7-0.4 11.4-8.5 9.2-14.9-1.5-4.6-5.2-8.9-9.9-10.6-2.3-0.7-4.9-0.8-7.3-0.3-0.7 0.2-0.6 0.9-0.8 1.7-0.7 5.1-2.6 10-3.4 15.1-0.9 6.8 0.2 13.8 1.1 20.6 0 0-0.6 0-0.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m323.6 341.1c2.4 0.5 3.9 3.2 4.3 5.3 1.4 6.8-5.1 12.6-11.7 10.1l-0.4-0.5c1.1-1 2.3-1.9 3.3-3 2.1-2 3.5-4.5 4-7.4 0.3-1.4 0.5-2.9 0-4.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m322.2 358.6c-1.4-3.7-4.5-5-1.5-7.9 0.7-0.8 1.8-1.5 3.5-3l0.6-0.2c1.4 3.8 0.9 8.7-2.1 11.5-0.1 0-0.5-0.4-0.5-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m308.4 316.6c-1.6-13.8 13.8-25.1 25.2-14.5 9.3 8.2 8.8 25.1-2.9 30l-0.4-0.4c6.8-6.9 6.6-18.7-0.8-25.1-5.9-6-13.3-2.1-17.4 3.8-1.4 1.9-2.4 4-3.1 6.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m336.7 323.4c5.2 1.8 6.9 7.6 3.5 11.6-1.1 1.1-2.5 2.3-4.9 2.7l-0.6-0.3c1.2-4.5 1.8-9.3 1.4-13.9 0 0 0.6-0.1 0.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m356.6 333.4c-1.4 1.8-4.5 2.7-6 3.8-0.3 0.2-0.4 0.4-0.3 0.5 0.1 0.3 0.5 0.1 0.7 0-0.7 0.8-1.4 1.4-2.2 1.9-5.7 3.4-11.5-0.3-12.1-6.6-0.2-2 0.3-3.8 0.6-5.7 0-0.4 0-0.6 0-1l0.2-0.5c1.1 0.5 1.7 1.5 2.3 2.4 1.2 2.2 1.8 4.9 3.8 6.5 0.9 0.6 2.4-0.2 3.1-0.9 1.8-1.8 4.5-1.4 6.8-1.2 1 0.1 2.1 0.2 3.1 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m343 330.8c-1.2-5.3-1.8-10-4.2-14.3l-1.5-2.6c-1.2-2-1.9-5-2.2-7.3-1-7.5-0.6-16.2 5.8-21.7 6.5-5.6 16.9-4.2 23.4-0.4 6.1 3.2 7.3 7.7 7.7 14.1 1 8.3-2.8 15.2-10.9 17.7q-3.2 1-6.5 1.1l-0.2-0.5c2-0.7 3.9-1.5 5.7-2.5 7.7-4.1 8.7-10.1 6.6-18-0.3-1-0.5-2-0.8-2.9-0.7-1.9-2.4-3-4.2-3.9-3.6-1.9-7.7-2.9-11.7-2.4-9.3 1.2-10.6 11.4-10.1 19.2-0.1 4.2 2.5 7.8 3.3 11.8 0.8 4.2 0.6 8.4 0.4 12.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m369.3 307.1c2.9 2.5 3.6 7 3.7 10.3 0.2 0.9 0.2 2.8-0.6 4.2-0.4 0.9-0.9 1.5-1.4 1.9-1.1 1.1-2.1 1.4-3.5 2-1.9 0.7-4 1.1-6.8 0.8l-0.4-0.5q2-2 4-3.9c0.8-0.9 2.1-1.7 2.7-2.7q0.2-0.4 0.1-1.1c-0.1-1 0.1-2 0.2-2.9 0.4-2.7 1.3-5.4 1.4-8.1 0 0 0.6 0 0.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m369.8 319c2.6-4.5 9.6-5.2 13.1-1.7 1.4 1.2 2.2 2.8 3.3 4.3l0.1 0.5c-5.7 0.8-10.9-2.4-16.4-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m403 318.8c0.8 5.9-6 8.9-9.9 5-1.1-1.2-1.7-2.7-1.6-5l0.3-0.6c3.5 1.7 7.4 1.8 10.9 0 0 0 0.3 0.6 0.3 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m373.5 318.6c-1-4.2-1.6-8.4-2.1-12.6-0.9-7.2-0.9-15.2 4.3-21 2.6-3.1 6.7-4.7 10.3-5.8 9.3-3.4 19.3-0.9 21.6 9.8 1.7 6.7 1.2 13.7 0.3 20.4-0.6 7.1-7.9 8.2-13.6 7.8-3.6 0-8.2-2.8-7.5-6.8h0.6c0.1 1.9 1.9 3.5 3.8 4 2.9 0.6 6.1-0.3 9-1.2 3.7-1.2 3.4-3.9 3.4-7.2 0-6.2-0.1-12.6-2.7-18.3-1.7-3.8-6.4-4.5-10.2-3.6-6.5 1.5-11.9 2.9-14.3 9.8-1.5 3.8-1.6 8-1.8 12.2l-0.5 12.6c0-0.1-0.6-0.1-0.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m485 376.3c1.6-1.1 2.9-2.6 4.2-4 3.8-4.2 12.4-7 16.7-1.8v0.6c-7.5-0.2-13.3 8.3-21 5.8 0 0 0.1-0.6 0.1-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m504.4 348.6c1 0.9 2 1.3 3.1 2.1 2.9 2.3 5.6 5.2 8.1 7.8 6.4 6.9 12.1 12.8 19.6 18.4 3.6 2.8 7.6 5.6 11.5 9.3l-0.2 0.5-3.5-1.2c-13.9-4.9-23.3-11.9-31.3-24.3-2.1-2.9-3.9-6.2-5.8-9.2-0.7-1-1.6-1.9-2.1-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m318.2 405.1c3.2-4 5.6-6.6 10.5-6 1.4 0.2 3 0.5 5.4 1.4l0.4 0.5c-4.4 3.7-10.6 5.5-16.3 4.7-0.1 0 0-0.6 0-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m326.8 411.8c10.2-7 15-16.1 22.8-25.3 8-9.6 19.8-17.1 32.5-17.2l0.2 0.6c-5.5 2.1-10.7 4.9-15.4 8.3-14.5 9.9-21.8 29.7-39.9 34.2 0 0-0.2-0.6-0.2-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m398.6 379.4c6.5-3.9 13.3-5 20.5-5.1 6.1 0.1 9.2 1 13.8-2.3 0.9-0.5 1.6-1 2.5-1.5l0.5 0.3c-3.7 8.2-8.3 9.7-16.8 9.5l-10.2-0.1c-2.6 0-7.7-0.1-10.3-0.2 0 0 0-0.6 0-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m431.1 416.5c-2.5 3.5-5.7 8.3-9 11.2-10.6 9.9-26.1 15.7-40.5 12l-0.1-0.6c2.2-0.4 4.5-0.8 6.7-1.4 11.1-2.7 21.7-7.5 31.2-13.9 3.9-2.6 7.3-5.7 11.5-7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m427 480.3c-3 4.2-4.9 8.6-7.6 13-2.5 4.2-5.1 8.3-7.8 12.4-5.7 8.4-11 16.3-18.3 23.8l-0.6-0.3c0.9-2.3 1.9-4.6 2.9-6.9 5.3-11.5 12-22.4 20.1-32.1 3.3-3.8 6.5-7.9 11-10.5 0 0.1 0.3 0.6 0.3 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m468.2 419.3c6.2-3.6 12.5-4.5 19.1-5.4 6.6-0.7 11.8-1 18.9-1.3l0.3 0.5-2.1 1.4-2.1 1.2c-10.5 5.3-22.7 5-34.1 4.1 0 0.1 0-0.6 0-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m461.8 477.8c7.9 4.1 13.3 9.2 18.8 15.9 1.7 2.1 3.4 4.4 5.1 7.5l-0.3 0.6c-7.9-3.5-14.8-9.2-19.8-16.3-1.2-1.6-2.6-3.8-3.4-5.5l-1-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m475.5 702.1c-10.3-29.1-13.9-62.3-2-91.4 0.6-1.5 2.5-5.2 3.2-6.7 0.6-1.3 1.8-3.1 2.5-4.3 0.4-0.8 1.4-2.5 1.9-3.2 0.4-0.6 3.1-4.3 3.7-5 7.4-9.6 17.8-17.3 24.1-27.6 6.5-10.2 11.2-22.3 17.8-32.6 13.4-21.7 31.1-40.7 51.9-55.4 10.4-7.2 21.4-13.4 33-18.2l0.2 0.5c-35.8 18.7-65.9 48.3-84.8 84.1-5.9 10.9-10.4 22.8-18.6 32.4-7.7 8.8-16.9 16.1-23.4 25.9-18.4 27.7-17.6 63.2-10.6 94.5 0.4 2 1.2 5 1.6 6.8 0 0-0.5 0.2-0.5 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m538.2 518.8c-5-27.4 4.3-56.9 21.6-78.5 5.2-6.6 11.2-12.4 17.8-17.5 12.8-9.9 28.3-15.3 40.5-25.6l0.4 0.4c-4.1 4.9-9.1 9-14.3 12.7-5.2 3.7-10.6 7.1-15.7 10.8-10.4 7.2-19.4 16.4-26.9 26.6-14.9 20.5-23.3 45.7-22.8 71.1 0 0-0.6 0-0.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m623.5 453.5c5.1-2.3 9.6-4.8 13.9-8.1 1.5-1.1 2.4-1.8 2.9-3.3 3.6-16 7.5-32.1 13.9-47.3 4.6-10.5 13.4-21.7 25.6-22.6l0.1 0.6c-8.4 2.7-14.4 10.1-18.2 17.8-3.8 8-5.9 16.6-8.5 25-0.6 1.8-8.2 27.7-8.9 28.5-1 2.1-3.1 3.5-5.1 4.5-4.8 2.7-10.2 4.6-15.7 5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m664.4 383c-5.4-4-7.9-9.7-7.1-16.3 0.8-6.6 7.8-14 14.7-10.7l0.1 0.6c-1.2 0.2-2.4 0.7-3.4 1.4-6.6 4.7-6.4 13.9-4.6 21q0.4 1.9 0.8 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m660.5 365.6c-10.6-18.6-19.5-43.2-7.4-63.3 6.4-10.3 13.3-21.1 24.5-26.8 4.5-2.4 10-3 14.8-1.1l-0.2 0.6c-4.5-0.6-9.2 0.5-12.9 3.2-7.7 5.1-12.7 13.2-17.6 21-2.4 3.9-4.8 7.9-6.3 12.2-3.2 8.7-2.9 18.2-1.3 27.2 1.6 9.1 4.5 17.9 6.9 26.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m692.5 274.5c3.5 2.1 5.7 5.9 7.9 9.1 7.9 11.9 13.1 25.4 17.1 39l-7.4-0.1c-4-0.1-6.1-1.6-8.9-3.6-9.5-7-14.9-20.1-14.3-31.6 0.5-4.6 1.7-9.5 5.1-12.7l0.5 0.3c-3 5.5-2.8 12.4-1.2 18.4 2.3 8 6.5 15.9 13.4 20.8 1.7 1.2 3.5 2.4 5.4 2.5l-0.6 0.7c-3.3-11-7.3-21.9-12-32.4-1.5-3.4-2.8-7.2-5.4-10 0 0 0.4-0.4 0.4-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m712.5 315.9c7.4 10.3 14.7 20.9 20.5 32.3 3.9 7.9 7.9 16.2 8.6 25.1 0.4 4.4 0.7 8.8 0.3 13.6-0.8 8.3-1.5 16.5-1.9 24.8-0.8 12.4-0.8 24.9-0.7 37.4 0.3 20.8 1.9 41.9 3.2 62.7l-0.6 0.1c-3.2-16.5-5.6-33.2-7-50-1.4-16.8-1.7-33.7-0.9-50.5 0.5-8.4 1.3-16.8 2.3-25.2 0.4-4.1 0.4-8.3 0-12.5-0.3-4.1-0.9-8.3-2.4-12.2-2.8-7.9-6.2-15.6-10-23.1-3.8-7.5-8-14.8-12-22.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m671.5 729.8c-14.2-22.5-23.4-43.3-16.7-70.5 4.7-18.7 15.2-35.6 25.6-51.5 10.5-15.6 21.4-31.3 34.1-45.4 5.4-5.8 11.4-11.5 16.5-17.4 3.2-3.8 6.5-7.5 8-12.3 1.7-4.8 2.3-10 2.6-15.1 0.2-5.3 0.1-10.6-1.2-15.8l0.5-0.2c1 2.6 1.6 5.2 2 7.9 1.1 8 1.2 16.2-0.8 24-1.3 5.3-4.7 9.8-8 14-3.3 4.3-6.9 8.2-10.5 12.2-14.4 15.8-26.4 33.6-38.2 51.4-5.9 8.9-11.7 17.9-16.7 27.4-4.3 8.2-7.9 17-10 26-2.7 11.7-2.4 24 1.1 35.5 2.9 10.3 7.6 20 12.3 29.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m737.8 410.5c0.8 4.5 1.5 8.8 4.6 12.1 0.3 0.5 0.7 0.9 1 1.4 11.6 16.3 4.8 34.5-4.6 49.9l-0.6-0.1q0.7-4.1 1.6-8.1c1.8-7.6 4.3-16.1 3.7-24-0.3-5.3-1.6-10.7-4.2-15.3-0.7-1.2-1.5-2.4-1.9-3.7-1.4-4-1.2-8.4-0.2-12.4 0 0 0.6 0.2 0.6 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m588.1 419.1c-9.1 0.7-15.4-9.1-11.1-17.1l0.6-0.3c3 6.1 6.7 11.8 11 17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m630.6 398.2c4.4-4.2 5.5-9 11-12.7 5.7-3.8 13.3-3.9 19 0.1v0.6q-2 0.2-4.1 0.5c-4 0.4-8.2 1.4-11.5 3.8-4.5 2.9-8.4 8.3-14.3 8.3 0 0-0.1-0.6-0.1-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m595.9 339.7c3.4 11.7 11.4 19.7 19.7 28.4 8.7 8.8 14.9 17.9 26.5 23.3l-0.1 0.6c-12.8-1.1-22.2-11.1-30.7-19.8-8.4-8.7-16.9-19.7-15.9-32.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m610.7 420.1c3.8 5.9 4.3 11.3 6.4 17.2 1.5 3.2 3 7.9-0.1 10.8-0.3 0.3-0.7 0.5-1.1 0.6l-0.5-0.3c1.8-3.7-2-6.7-3.7-9.6-2-3.3-2.4-7.4-2.4-11.2 0.1-2.5 0.4-5 0.8-7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m602.1 426.1c3.1 4.5 5.6 6.1 6.5 11.2 0.3 1.4 0.5 3 1.2 5.6l-0.2 0.6c-5.9-2.2-9.6-8.9-8.7-15.1l0.3-1.3 0.4-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m534.8 276c-20.7-9.4-38-29.7-49.4-49.1-4.4-8-8.5-16.2-10.1-25.4-1.5-9.5 0.5-20.3 7.6-27.2 4.6-4.3 11.6-6.8 17.6-4.2l-0.2 0.6c-5.5-1.3-11.4 1.5-14.9 5.7-11.7 14.5-2.9 33.6 5.2 47.5 5.7 10 12.3 19.3 19.7 28.1 7.3 8.7 15.4 17 24.8 23.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m500.6 170.2c8.9 6.3 20 9.7 28.4 17 6.8 5.5 13.8 11.6 20.4 17.3 23.6 20.7 47.2 41.9 71.6 61.6 2.2 1.9 6.9 5.6 9.2 7.4 3.2 2.5 6.5 5.3 8.9 8.5 2.6 3.1 4.9 6.3 7.3 9.5l-0.4 0.4c-5.6-5.6-10.7-11.8-17.6-15.8-6.6-4.3-13-8.9-19.4-13.7-12.7-9.4-25-19.5-36.9-30-16.3-14.2-32.1-29.6-47.9-44.4-7.5-6.4-16.7-10.5-24-17.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m642.5 287.1c2.9 0.1 5 1.2 6.7 2.4 5.4 3.7 6.9 7.8 9.1 14l-0.2 0.6c-7.7-2.7-11.6-10.4-16.1-16.7 0 0 0.5-0.3 0.5-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m526.3 266.1c4-1.7 7-4.9 10.7-7 3.6-2.4 8.1-3.9 11.9-6l0.5 0.1c-1.2 4.8-5.3 8.3-9.3 11-4.1 2.4-9.3 4.4-14 2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m573.4 315.7c5.5-1.4 10.5-3.6 16-5.1 4-1.1 8.2-2 12.5-2.4 1.5-0.1 3-0.2 4.9-0.2l0.3 0.5c-2.3 1.9-4.9 3.4-7.7 4.7-6.1 2.8-12.8 4.8-19.6 4.6-2.2-0.1-4.6-0.6-6.6-1.5 0 0 0.2-0.6 0.2-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m596 334.9c-5-11.3 1.8-24.9 12-30.6 3.5-1.9 7.4-3.1 11.6-2.7l0.2 0.6-2.3 1.2c-1.1 0.7-3.3 2.1-4.4 2.9l-2 1.6c-7.2 6.3-12.3 15-14.1 24.4l-0.4 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m481.7 267.2c-20.2-12.2-33.8-34.5-37.8-57.7-3.2-17.5-0.2-33 18.6-38.8 5.2-2.3 7.2-0.6 11.4 2.5 1.9 1.5 4.6 3.4 6.4 5l-0.2 0.5-7.2-3.7c-1.2-0.5-4.1-2.2-5.3-2.3-0.6-0.1-1.2 0.1-1.8 0.3-7.5 3.3-14.2 7.2-16.3 15.8-3.8 15.5 4.7 39.6 12.6 53.1 5.4 9.2 12.2 17.7 20 24.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m461 244.4c5.9 8.3 4.6 19.5-0.8 27.6-1.8 2.6-4.2 5-7.5 6.6l-0.5-0.3c0.5-1 1.4-3 1.9-4 3.5-8 5.6-16.7 6.1-25.5 0.1-1.1 0.2-3.3 0.2-4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m452.3 280.6c2.5 2.6 4.5 5.6 6.1 8.7v0.1c-0.8-3.2-5.1-4.7-7.8-2.5-1.2 0.9-1.9 2.5-1.9 3.7v-0.3c-0.5-5.6 1.1-11.9 5.7-15.8 0.5-0.5 1.3-1.1 2.2-1.2l0.4 0.5c-0.6 0.8-0.9 2-1.2 3.1-0.7 3.4-1 7-1.2 10.5-0.1 0.9-0.2 2.4-0.2 3.3 0 1-1.3 1.1-1.4 0.2-0.8-3.4-1.4-6.8-1.3-10.3 0 0 0.6 0 0.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m416.8 265.5c-0.2-5.6 0.4-10.9 3.5-15.9l4.3-6.1c7.2-9.9 13.5-20.3 23.4-28.3l0.5 0.3c-4.6 8.7-9.4 17.7-14.9 25.7-2.2 3.1-4.5 6-7 8.8-2.7 2.5-4.9 5.4-6.3 8.9-1.1 2.2-2 4.5-2.9 6.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m200.9 377.7c-0.8-11.1 6.2-20.7 11.7-29.6 13.6-21.9 25-45.2 39.7-66.6 3-4.4 7.1-8.8 12.2-10.8l0.4 0.6c-4.4 2.8-7.5 7.1-9.8 11.7l-7.1 13.9c-9.5 18.6-19.1 37.2-31.5 54-6 8.3-13.6 16.4-15 26.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m263.1 271.7c13-6.6 23.5-16.8 34.5-26.1 9.5-8.2 23.4-20.3 33-28.6 13.2-11 27-22.4 41.2-32.1 6.9-4.4 12.6-10.7 20-14.6 2.6-1.3 5.5-2.4 8.4-2.3q1.5 0 2.9 0.4l-0.1 0.6q-1.4-0.2-2.7-0.1c-6.4 1-11.1 5.9-15.7 10.1-5 5.3-10.9 9.8-16.6 14.3-28.3 23.1-55.1 48.2-85.2 69-6.1 4.1-12.6 7.6-19.5 10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m403.1 168.5c6.8 2.1 11.6 8 13.7 14.6 2 6.9 1.4 14.2-0.4 20.9-6.3 22.6-22.5 40.3-37.6 57.4-11 11.9-23.5 23.3-38.6 29.7l-0.3-0.5c5.4-3.4 10.4-7.4 15.2-11.7 4.7-4.3 9.1-8.9 13.4-13.7 8.4-9.6 16.5-19.6 24.4-29.6 10.6-14.2 23.8-33.3 20.8-51.8-1.3-6.1-5.2-11.9-10.8-14.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m415.1 182c-2.2-4.5 0.4-10.8 5.4-12.3 6-1.7 11.8 0.6 17.1 3.1 6.6 3.5 11.1 11.1 10.6 18.7 0 8.5 1.5 17.8-1.8 26.3h-0.6c0.1-8.8-2.5-17.3-3.3-26 0.1-5.7-3-11.2-7.9-14.1-3.7-2.1-7.7-4.2-11.9-4.4-4.3-0.2-7.4 4.7-7 8.6 0 0-0.6 0.1-0.6 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m418 261.7c-4 3.4-10.2 2.6-14.5 0.5-4.2-2.3-8.5-6.9-8.1-12.1l0.5-0.3q1 1.2 2.2 2.1c2.5 2 5.3 3.5 8.1 4.9 3.8 1.9 7.7 3.8 11.8 4.3 0 0 0 0.6 0 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m376 258.8c-7.9 3.2-18.1 1.6-23-5.5-2.7-3.7-5.6-9.7-3.7-14.2h0.6c0 0.6 0.3 1.3 0.6 1.9 2.6 4.2 5.9 8.1 9.7 11.2 2.3 1.6 5 2.6 7.7 3.5 2.7 0.9 5.5 1.6 8.3 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m277.9 290.6c3.1-1.6 6.9-0.4 9.7 0.8 6.4 3 10.7 8.2 14 14.1 0.3 0.6 1.2 2.1 1.6 2.6 0.2 0.4 0.4 0.6 0.7 1v0.6c-2.9-0.3-5.2-2.1-7.3-3.7-4.3-3.4-7.9-7.4-12-10.9-2-1.6-4.2-3.4-6.7-3.9 0 0 0-0.6 0-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m236 384.3c10.3-5.4 22.7-3.8 32.3 1.9 2.2 1.3 2.9 4.2 2.6 6.3-0.1 0.8-0.2 1.4 0.3 2.1l-0.1 0.6q-0.7-0.2-1.2-0.6c-1.5-1.4-1.6-3.8-3.4-4.7-3.7-1.1-7.7-1.7-11.6-2.4-6.2-1.2-12.6-1.9-18.9-2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m271.5 395c5.8-2.7 11.2 3.3 15 6.4 1.6 1.1 3.3 2.3 4.8 3.7 7.8 7.4 10.1 18.6 7.6 28.7l-0.6 0.2q-0.7-3-1.6-6c-1.6-5.8-3.7-11.7-7.6-16.4-1.8-2.5-4.3-4.3-6.4-6.5-3.3-3.5-5.7-9.2-11.1-9.4 0-0.1-0.1-0.7-0.1-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m288.6 406.4c5.9-8.4 20.4-2.8 19.2 7.3l-0.4 0.4q-1.9-1.8-4.1-3.2c-4.3-2.7-9.5-4.1-14.6-3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m266.6 388.5c5.9-13.7 12.6-26.2 18.6-39.5 3-6.5 5.9-13 8.8-19.6 3-6.7 5.9-13.4 9.6-20.1l0.6 0.1-1.2 5.4c-5.7 25.2-16.5 49.4-32.4 69.7l-3.5 4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m247.7 434.3c7.2-6.7 18.2-6.3 26.1-1.4 2.6 1.6 5 3.8 6.6 6.9l-0.3 0.6c-0.9-0.5-2.9-1.3-3.8-1.6-8.4-3.3-17.5-4.6-26.5-4.1l-2.1 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m249.8 458.7c9.1-5.5 21 2.1 28.8 6.9 8.1 5.5 15.9 12.4 19.8 21.9l-0.5 0.5c-8.5-8.3-18.7-14.9-28.6-21.3-5.8-3.8-12.2-8.4-19.4-7.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m294.6 446.7c2.9 7.7 4.4 17.6 6.1 25.5 1.6 8.7 4.9 15 8.6 23.4l-0.4 0.5c-11.7-9.7-15.2-21.3-15.5-36-0.1-4.5 0.1-9 0.6-13.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m312 489.6c1-4.4 2-6.9 3.6-10.1 1.9-3 3.7-5.9 7.4-8.4l0.6 0.1c-0.4 5.7-1.7 12-6.4 15.7-1.5 1.3-3.2 2.3-4.9 3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m187.6 413.2c8.3-5.4 18.1 1.8 24.9 6.7 14.1 10.3 25.8 24.6 31.7 41.2 2.9 8.4 4.3 17.3 3.1 26h-0.6c-1.1-8.3-3.4-16.4-6.9-24.1-7-15.2-18-28.4-30.4-39.6-3.2-2.7-6.3-5.6-9.9-7.7-3.5-2.1-7.8-3.6-11.7-2 0 0-0.2-0.5-0.2-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m253.4 480.2c14.7-2.9 29.5 1.1 43.4 5.8 1 0.3 3 1.1 4 1.5 15.1 6.4 26.7 18.8 38 30.3 23.8 24.8 47.2 50.3 66.6 78.8 3.8 5.5 7.4 11.2 10.8 16.9 5.5 10.8 9.2 22.6 10.3 34.6l-0.6 0.1c-0.9-5.1-2.5-10.2-4.3-15.1-2.8-7.3-5.9-14.7-10.5-21.1-16.5-23.8-35.4-45.8-55-67.1-7.1-7.8-14.3-15.5-21.4-23.2-7.2-7.7-14.3-15.5-22.5-22.1-6.1-5-13-8.9-20.5-11.5-7.3-2.7-14.8-5.3-22.6-6.6-5.2-0.9-10.4-1.1-15.7-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m416 618.3c6.8 4.7 12.5 10.9 18.1 16.8 3.5 3.7 7.5 7.1 9 12.6 0.3 0.9 1 3.5 1.3 4.6 1.4 5.9 3 11.8 2.9 18-0.7 6.6-2.3 13-3.6 19.4-1.2 5.9-1.1 11.6-1.2 17.8l-0.6 0.1c-1-3.9-1.9-7.9-2.2-12-0.6-8.6 1.4-17.2 1.9-25.7-0.3-5.5-1.8-10.9-3-16.3-0.4-1.9-0.9-3.9-1.5-5.8-1.4-3.7-4.5-6.6-6.8-9.8-4.3-5.6-10.2-13.9-14.7-19.3 0 0 0.4-0.4 0.4-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m444.4 658.6c-6.2-14.1-6.4-26.8 4.3-38.6 4.3-4.8 8.6-9.9 13.6-13.8 5.5-4.1 12.2-6.6 19-6.3l0.2 0.6c-7.4 2.2-14.2 6.6-19.1 12.6-1.9 2.2-7.1 8.4-9.1 10.7-7.1 7.7-9.4 15-8.9 25.4 0.1 3.1 0.4 6.2 0.6 9.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m444.9 663.1c2.5 10.2 4.4 23.6 6.3 33.8 1.9 11.4 4.4 22.1 5.9 33.9l-0.5 0.3c-1-2-2.9-5.9-3.8-7.9-0.8-2.1-2.4-6.2-3.1-8.2-5.2-15.3-7.2-31.6-5.9-47.6l0.5-4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m132.1 325.5c7.7-2.9 16.4-2.8 24.4-1.1 8.4 2 16 6.8 22 13 11.6 11.9 17.1 28.5 19.9 44.5 1.9 10.5 3.7 21.6 0.7 32l-0.6-0.1c0.7-10.4-2.1-20.6-4.7-30.7-5.9-24.4-18.3-52.6-46.1-56.6-5.1-0.9-10.3-1.2-15.5-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m130.6 369.6c4.9 15.8 5.1 33.4-1.5 48.8 0.7-1.7-0.6-4.3-2.5-4.7-0.9-0.2-1.7 0-1.9 0.3 0 0 0.1 0.1 0.1 0q0.2-0.1 0.3-0.2c5.8-4.2 11.6-8 18.4-11l0.4 0.4-6.8 6.4-6.8 6.3c-1.1 1-2.3 2.5-3.8 3-0.9 0.3-2.2 0-2.7-1-0.2-0.5-0.1-1.1 0-1.5 1.2-3.3 2.2-6.6 2.9-10 2-9 2.6-18.3 2.9-27.6q0.2-4.6 0.3-9.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m124.6 416.6c5.7 5.6 6.8 13.2 4.6 20.3-0.3 1.1-0.7 1.9-0.8 3.4l-0.4 0.5c-3-3.2-3.2-7.8-3.8-11.8-0.2-3-0.3-6.3-0.3-9.3l0.1-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m127.9 438c-2.7-3.4-0.7-8.8 2.1-11.2 2.8-2.5 7.8-3.5 11.1-1.2v0.6c-2.6 1.1-5 3.3-7.1 5.1-2.1 2-4.5 4-5.5 6.8 0 0-0.6-0.1-0.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m127.9 438.7c2.1 6.9 6.8 13.3 10.3 19.6 7.2 13 13.7 26.7 19.4 40.4 6.5 16.2 14.1 32.5 15.8 50.2l-0.6 0.2c-3-9.5-7-18.6-11.2-27.6-7.4-15.3-17.4-38.9-24.2-54.7-3.2-8.1-9.5-19.3-10.1-28.1 0 0 0.6 0 0.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m173.2 548c3.2 13.1 0.5 27.3 8.7 38.9 7.4 11.2 18 19.8 27.5 29.7 6.4 6.5 12.8 13.2 19.3 19.8 8.1 8.6 16.8 17.4 22 28.3 3.3 6.5 5.5 13.6 7 20.7 3.9 18.7 3.5 36.9 7.9 54.9l-0.6 0.2c-9.2-24.8-7-53.1-20.7-76.3-5.4-8.9-12.8-16.2-19.9-23.7l-19.1-20c-9.1-9.9-20.3-19.9-26.9-31.7-7.9-12.7-4.2-26.8-5.8-40.7 0 0 0.6-0.1 0.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m132.4 326.1c-0.9 0.2-1.5 1-2.2 1.5 0.1 0.2-0.2 0.7-0.3 1-0.1 0-0.2 0.2-0.1 0.2v-0.1c0.1 0 0.2 0.3 0.3 0.9 0.5 2 0.9 4 1.3 6 0.8 4 1.5 8.2 2 12.2 1.1 8 1.9 16.3 2.3 24.3l-5.4-5.1c3.2-0.2 6-2.5 8.5-4.9 1.1-1.2 2.5-2.6 3.1-3.9 0.4-0.6 0.7-3 0.8-4.1 0.9-4.8 0.9-9.9 0.3-14.8-0.5-4.6-1.6-9.1-2.9-13.8l0.5-0.3c4.8 8.3 7.8 17.8 7.3 27.5l-0.2 3.6c0.1 3.8-2.2 7.2-4.7 9.7-3.4 3.7-7.9 7.1-13.2 6.9v-0.5c-0.3-8.1-1.2-28.8-1.5-36.6l-0.2-6.2c0-0.4-0.1-1 0.2-1.6 0.5-0.6 0.6-1 1.2-1.5 0.9-0.5 1.8-1 2.8-1 0.1 0 0.1 0.6 0.1 0.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m817.4 286.1c-2-2.5-4.9-5.7-6-8.7-2.3-3.6-4.7-7.2-7.1-10.7-1.8-2.9-3.6-5.7-5.5-8.5-3-4.6-5.6-9.5-8.8-14-2.1-3.1-4.1-6.2-6.1-9.3 2.4-0.1 4.7 0 6.9-0.4 1.7-0.3 2.5-0.5 3.6 1.5 4.7 8.7 12.1 13.6 21.3 15.5 6.8 1.5 13.7 1.4 20.6 1.6 1.3 0.1 2.6 0 3.1-1.5 0.4-1.2-0.6-2-1.3-2.8-5.1-6-10.5-11.6-17.7-14.9-4.8-2.2-9.5-4.2-14.9-4.3-5.7-0.2-11.3 1.2-16.9 1.6-3.8 0.3-7.3 0.2-9.8-3.2 1.5 2.5 3.2 5 5.5 6.7-2.3-1.7-4-4.2-5.5-6.7q-0.2-0.3-0.4-0.7c-4.6-7.2-10-13.7-15.1-20.5-4.8-6.5-9.9-12.8-15-19.1-5.8-7.1-11.7-14.1-17.5-21.2-0.7-0.8-1.7-1.4-2.1-2.9 1.1 0.3 2.1 0.6 3 0.8 6.2 1.6 12.4 2.5 18.7 1 1.2-0.3 2.1-0.7 3.3 0 3.5 2.3 7.1 4.1 10.9 5.8 3.3 1.6 6.7 3 10.4 3.6 4 0.8 7.5-0.9 11-2.7 6.1-3.3 12.4-6.4 18.6-9.7 2.7-1.5 2.7-2.8 0.5-4.8-3.2-2.9-7.1-4.1-11-5.8-5-2.2-10.2-3-15.3-0.9-6.5 2.8-13.1 5.2-19.8 7.6-4.2 1.5-8.2 3.8-12.8 3.9-6 0.2-12-0.8-17.7-2.9-2.7-1.1-5.5-2.4-7.6-4.5-1.9-1.9-3.4-4.2-5.3-6.2-5.1-5.4-10-11-15.1-16.4-3.5-3.7-7.3-7-10.9-10.5-1.5-1.5-3.2-2.8-4.8-4.2-1.9-1.5-4.1-2.5-6.1-4.7 2.6 0 4.8 0 6.7-0.9q6.8-3 12.2 2.1c5 4.8 11 7.4 17.7 8.1 8.9 0.9 17.3-2.2 25.9-4 0.8-0.2 1.5-0.8 1.7-1.8 0.2-1.3-0.4-1.9-1.2-2.5-1-0.7-2-1.3-3-2.2-4.4-4.2-8.8-8.3-13.7-11.8-2.6-1.8-5.5-2.9-8.5-3.1-6.8-0.6-12.9 1.6-18.8 5.4-3.5 2.3-6.1 6.1-11.1 6.4-3 0.1-6.2 1.1-9.3 1.2-2.1 0-4.2 0-6.1-1.3-7.5-5.1-15.5-8.8-24-11.6-9.1-3-18.4-4.6-27.9-4.9-10.4-0.3-20.8 0.1-31.2 0.6-1.3 0.1-2.6 0.5-4.3-0.1 1.9-0.9 3.4-1.5 5-2.2 5.6-2.5 11.4-4.9 15.9-9.4 2.7-2.5 4.9-2.9 8.1-1.2 4.3 2.2 9.1 2.7 13.9 1.4 4-1 7.8-2.8 11.3-5.2 6.6-4.6 11.5-10.2 11.8-19 0-2.7-1.4-4.3-4-4.3-4.2 0-8.1 1.5-12 2.9-6.3 2.3-12.5 4.8-17.2 10.1-3.5 3.9-7.2 7.5-11 11.2-2 2-5.7 4.7-8.1 6.1-5.2 3-10.4 5.7-16.1 7.6-4.5 1.4-9.1 3-13.9 2.8-2.7-0.1-5.3-0.2-7.9-0.6-5.7-0.8-11.4-2.2-17-3.8-3.8-1.2-7.7-2.4-11.8-2.9-1.3-0.2-1.8 0.5-2 1.6-0.3 1.2 0.2 1.9 1.3 2.1q2.1 0.6 4.1 1.1c6.1 1.6 12.1 3.3 18.2 4.6 9 1.8 18 2.1 27.2 1.9 8.1-0.2 16.3-0.4 24.4-0.7l8.8 0.2c8.9-0.2 17.2 0.8 25.5 2.7 10.1 2.4 19.5 6.4 28.4 11.8 6 3.6 11.6 7.7 17.2 12 1.6 1.3 3.1 2.9 4.3 4.7 2.2 3.4 4 7.1 5.8 10.7 2.6 5.2 4.8 10.6 5.3 16.6 0.1 2.1 0.3 3.3-1.8 5.1-4.9 4-7.5 10.1-9.7 16.1-2.9 8.5-2 16.8 1.3 24.9 1.2 2.8 2.4 5.6 4.3 8 1.5 1.9 2.9 1.9 3.9-0.1 1.8-3.8 3.7-7.6 5.3-11.6 3.3-8.1 4.3-16.5 2.8-25.3-0.5-3.2-1.3-6.3-1.8-9.4-0.8-5.7-1.3-11.5-2.8-17-0.9-3.1-2.3-6-3.8-9.2 1.2 0.1 1.9 0.7 2.4 1.4 0.8 1 1.5 2.1 2.3 3 3.7 3.9 7.3 8 10.6 12.2 1.6 2 3.3 4 4.9 6 2.8 3.5 5.7 6.9 8.6 10.3 1.8 2.2 3.6 4.5 5.4 6.7 3.4 4.2 6.9 8.3 10.2 12.5 0.9 1.1 1.7 2.2 2.2 3.4 3.5 8.1 6.5 16.3 5.1 25.6-0.3 1.7-0.7 1.8-1.9 1.4-8.7-2.8-15.3 1.8-18 10.8-2 7-2 14.1-1.5 21.3 0.1 2.1 0.4 4.2 1.3 6.1 1 2.2 2.2 2.4 3.7 0.6 1-1.2 1.7-2.5 2.4-3.8 3.3-6.3 6.3-12.7 10.9-18 1.2-1.3 2.2-2.9 2.9-4.6 2.7-6.8 3.5-14 3.3-21.3-0.1-3.5-1.3-6.7-2-10.1 0.8 0 1.1 0.5 1.3 0.9 2 3.4 4.8 6 7 9.1 4.4 6.1 9 11.9 13.5 17.9q9 11.6 16.9 24c1.4 2.2 2.3 4.7 2.7 7.4 0.8 7.6-1.2 14.9-3.2 22.1-1.5 5.4-3.8 10.7-4.3 16.5-0.6 7.8 1.2 15.1 8.9 20.3 2.5 1.7 4.5 4.3 5.9 7.3 1.7 3.6 4.1 3.6 4.8 0.6 0.4-1.4 0.5-2.9 0.7-4.4 1.2-7 1.1-13.8-1.6-20.4-2.1-5-5.3-9.4-9.1-13.1-1.7-1.8-2.2-3.5-1.8-5.9 1-6.5 3.1-12.7 3.2-19.8 2.3 3 4.3 5.5 6.3 8.1 2.9 4 5.5 8.2 8.6 12q1 1.3 1.9 2.7-0.3-0.6-0.5-1.3 0.2 0.7 0.5 1.3 1 1.4 1.8 3c2 2.9 4.6 5.6 6.1 8.7 0.3 0.1 0.4 0.2 0.5 0.3q3.1 4.4 6.2 8.8c2.3 3.4 4.7 6.8 6.9 10.2 2.6 3.9 5.2 7.5 8.4 10.8 5.4 5.6 12.1 8 19 10.1 4.9 1.5 9.8 2.8 13.7 6.4 0.7 0.7 1.5 1.6 2.8 0.2 0.5-0.6 0.8-1.5 0.8-2.3 0-5.8-0.7-11.5-2.6-17-1.9-5.4-5-10-10.3-12.3-4.1-1.9-8.6-2.3-13-2.6-5.4-0.2-10.8-0.2-16.1 0.7-1.7 0.3-2.4-0.2-3.2-1.4-3.7-6.5-8.1-12.4-12.1-18.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m54.6 510.7c0.9 2.9 2.4 6.8 2.2 9.6 0.8 3.8 1.7 7.7 2.6 11.5 0.6 3.1 1.2 6.1 1.8 9.1 1.1 5 1.6 10 2.9 14.9 0.8 3.4 1.4 6.7 2.1 10-2.4-1.2-4.5-2.4-6.8-3.2-1.6-0.6-2.5-0.9-2.7-3-1.1-8.7-6.1-16.2-14.1-22.3-6-4.5-12.6-8-19.1-11.7-1.2-0.6-2.4-1.2-3.5-0.4-0.9 0.7-0.2 1.8 0.1 2.8 2.5 7 5.4 13.9 11 20 3.7 4 7.4 8 12.4 10.8 5.4 3 11.3 4.8 16.8 7.4 3.7 1.7 7 3.5 8 7.4-0.4-2.7-1-5.4-2.5-7.8 1.5 2.4 2.1 5.1 2.5 7.8q0.1 0.3 0.2 0.6c1.5 7.7 4.1 15.3 6.2 22.9 2 7.3 4.3 14.6 6.7 21.9 2.7 8.2 5.5 16.4 8.3 24.6 0.3 1 1 1.9 0.8 3.2-0.9-0.8-1.8-1.5-2.6-2.1-5.2-4.3-10.8-8.1-17.3-10.2-1.3-0.4-2.4-0.6-3.2-1.7-2.4-3.5-5.2-6.7-8-9.9-2.6-2.8-5.3-5.6-8.5-7.9-3.6-2.6-7.5-3.2-11.6-3.6-7.2-0.6-14.4-1.5-21.6-2.2-3.1-0.3-3.7 0.6-2.3 3.3 1.9 3.7 5.1 6.7 8.1 9.9 3.9 4.1 8.5 7.4 14.2 8.4 7.4 1.2 14.6 2.9 21.9 4.4 4.6 1 9.3 1.4 13.7 3.6 5.9 3 11.2 6.7 15.7 11.2 2.2 2.2 4.3 4.5 5.5 7.2 1.1 2.4 1.6 4.9 2.6 7.3 2.7 6.6 5.1 13.2 7.9 19.8 1.8 4.5 4.2 8.9 6.2 13.4 0.8 1.9 1.9 3.7 2.9 5.5 1.2 2.1 2.9 4 4 6.6-2.5-1.3-4.6-2.4-6.8-2.7q-7.7-1.2-10.8-7.8c-2.8-6.1-7.5-11.1-13.6-15-8.1-5.2-17.4-7.1-26.3-10.2-0.8-0.2-1.7-0.2-2.4 0.5-0.6 0.8-0.3 1.7 0.2 2.5 0.7 1 1.5 2 2 3.1 2.5 5.4 5.1 10.7 8.4 15.8 1.7 2.6 4.1 4.9 6.8 6.6 6.3 3.9 13 5.4 20 5.5 4.3 0.1 8.3-1.4 13.2 0.9 2.9 1.5 6.3 2.3 9.4 3.9 2 1 4 2 5.3 4 5 7.6 11.2 14.4 18.2 20.9 7.4 6.8 15.6 12.7 24.5 17.7 9.8 5.5 19.9 10.5 30 15.4 1.3 0.6 2.7 1 4.1 2.3-2.2-0.3-3.9-0.6-5.6-0.9-6.4-1-12.8-2.1-18.9-1.1-3.5 0.5-5.8-0.3-8.2-3.2-3.2-3.8-7.6-6.6-12.6-8.1-4.3-1.3-8.6-1.9-13-1.9-8.1 0.1-14.9 1.7-18.6 8.2-1.2 1.9-0.4 3.8 2 5.1 4 2.2 8.3 3 12.6 4 6.9 1.5 13.9 2.8 20.4 1.2 4.9-1.1 9.9-1.9 14.9-2.7 2.7-0.5 7.3-0.7 10.1-0.5 6.1 0.5 12.3 1.1 18.3 2.6 4.9 1.2 9.9 2.3 14.5 5 2.4 1.4 4.9 2.8 7.2 4.4 5.2 3.5 10 7.4 14.6 11.5 3.3 2.8 6.5 5.7 10.1 8.1 1.2 0.8 2 0.6 2.7-0.1 0.7-0.7 0.4-1.5-0.5-2.3q-1.7-1.4-3.5-2.9c-5.1-4.2-10.1-8.6-15.5-12.6-7.7-6-16.3-10.8-25.1-15.2-7.8-4-15.6-8.1-23.5-12l-8.3-4.6c-8.6-4.4-16.1-9.3-23.2-14.9-8.7-6.9-16-14.7-22.4-23.2-4.3-5.7-8-11.7-11.6-17.7-1-1.8-1.8-3.7-2.2-5.7-0.8-3.6-1-7.2-1.3-10.9-0.4-5.2-0.3-10.3 1.6-15 0.6-1.6 0.9-2.6 3.7-2.9 6.2-0.5 11.1-3.6 15.6-7 6.1-4.8 8.6-11.5 8.6-19.2 0-2.7 0-5.4-0.9-8.1-0.6-2.2-2-2.9-3.7-1.9-3.3 1.9-6.6 3.8-9.7 5.9-6.4 4.4-10.6 10.1-12.7 17.4-0.7 2.6-1.2 5.3-2.1 7.9-1.4 4.7-3.2 9.2-4 14.1-0.4 2.8-0.2 5.6 0 8.8-1.1-0.8-1.5-1.6-1.7-2.3-0.4-1.2-0.7-2.3-1.1-3.4-1.9-4.8-3.7-9.6-5.2-14.5-0.7-2.3-1.6-4.6-2.3-6.9-1.2-4-2.7-8-4-12-0.9-2.6-1.7-5.2-2.5-7.8-1.6-4.8-3.3-9.6-4.8-14.5-0.4-1.2-0.8-2.4-0.8-3.6 0-7.7 0.3-15.4 5.3-21.5 1-1.2 1.4-1.1 2.4-0.2 7.2 6.6 15.3 6.5 21.4 1.2 4.7-4.2 7.5-9.6 9.9-15.1 0.7-1.6 1.2-3.3 1.2-5.2q-0.2-3.2-3.3-2.3c-1.4 0.3-2.6 0.9-3.8 1.6-5.6 3-11 6.2-17.6 7.8-1.6 0.4-3.2 1.1-4.5 2-5.3 3.6-8.8 8.6-11.6 14.1-1.3 2.7-1.4 5.7-2.1 8.5-0.8-0.3-0.8-0.9-0.9-1.3-0.5-3.5-2.2-6.9-3.1-10.3-1.7-6.8-3.8-13.5-5.8-20.2q-3.8-13.2-6.5-26.4c-0.4-2.3-0.3-4.7 0.4-6.8 2.2-6.1 7-10.5 11.8-14.8 3.6-3.3 7.9-6.1 10.6-10.1 3.6-5.5 4.9-11.8-0.4-19.6-1.8-2.6-2.5-5.5-2.7-8.4-0.2-3.6-2.6-4.8-4.4-3-0.9 0.9-1.6 2-2.4 3-3.8 4.5-6.5 9.7-6.5 15.9 0 4.9 1.3 9.7 3.4 14.4 1 2.2 0.7 3.7-0.6 5.3-3.5 4.3-8 7.9-10.9 13.1-1-3.4-1.9-6.3-2.7-9.2-1.2-4.4-2-8.9-3.5-13.3q-0.4-1.5-0.8-3 0.1 0.6 0 1.2 0.1-0.6 0-1.2-0.3-1.6-0.4-3.1c-0.8-3.2-2.2-6.6-2.5-9.6-0.2-0.2-0.2-0.3-0.3-0.5-0.8-3.2-1.6-6.5-2.3-9.7-0.9-3.7-1.8-7.4-2.6-11.1-0.9-4.1-2-8.2-3.7-12.3-2.9-6.8-8.3-12-14.1-17.2-4-3.5-8.2-6.9-10.5-11.7-0.4-0.8-0.9-1.9-2.6-1.5-0.8 0.2-1.4 0.7-1.7 1.3-2.3 4.3-3.9 8.9-4.3 13.9-0.3 5 0.9 10 4.9 14.4 3.3 3.5 7.3 6.1 11.5 8.5 5 2.9 10.1 5.7 15.5 7.7 1.8 0.7 2.3 1.4 2.5 2.7 1 6.7 2.8 13.3 4.1 20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m78.7 552.7c-6.4-24.2-10.6-49.4-12.4-75.4-14.1-208.1 134.5-387.5 331.8-400.9 57-3.8 111.8 6.6 161.3 28.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m55.4 329c8.4 2.2 12.1 9.3 9.7 18.6l-2 7.9 10.9 2.9-1.6 6.5-38.1-9.7 3.7-14.6c2.4-9.3 9-13.7 17.4-11.6zm-1.7 6.6c-4.8-1.2-8.3 1.1-9.8 6.8l-1.9 7.7 15.1 3.9 1.9-7.7c1.5-5.7-0.5-9.4-5.3-10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m65.1 316.8c-10.8-4.2-15.7-15.2-11.5-25.7 4.1-10.5 15.1-15.2 26-10.9 10.8 4.3 15.7 15.2 11.5 25.7-4.1 10.6-15.2 15.2-26 10.9zm12-30.2c-7.5-3-14.9 0-17.6 6.9-2.7 6.8 0.7 14 8.1 17 7.5 2.9 14.9-0.1 17.6-6.9 2.7-6.9-0.7-14.1-8.1-17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m116.1 240.2l12.8 7-3.1 5.5-7.3-4.1-13.5 24.6 7.3 4-3.1 5.5-12.7-7.1 0.8-1.3c2.2-4.5-5-9.8-14.9-15.7l-10.7-6.4 12.9-23.4 29 16zm-14.8 26.7l9-16.3-23.6-13-6.9 12.5 6 3.6c7.6 4.6 14.2 9.2 15.5 13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m136.8 199.1c7 5.3 7.4 12.5 1.8 19.8l-9.6 12.5-31.2-23.7 4-5.4 10.6 8.1 6.1-8.1c5.3-6.9 11.6-8.2 18.3-3.2zm-4 5.5c-4-3-7.5-2-10.7 2.2l-5.3 7 11.8 9 5.3-7c3.2-4.2 2.9-8.2-1.1-11.2zm-13.4-25.3l4-5.4 31.3 23.8-4 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m167.8 155.8c-7.8-8.8-7-20.7 1.4-28.1 4.5-3.9 9.9-5.5 15.2-4.5l-0.4 6.2c-4-0.6-7.5 0.5-10.3 3-5.7 4.9-6.1 12.8-0.8 18.9 5.3 6.1 13.2 6.9 18.9 1.9 2.9-2.5 4.4-5.8 4.3-9.9l6.2 0.5c0.3 5.4-2.1 10.5-6.6 14.4-8.4 7.4-20.3 6.5-28-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m223.8 111.6c-5.8-10.1-2.8-21.7 7-27.3 9.9-5.6 21.3-2.3 27.1 7.8 5.8 10.2 2.8 21.7-7 27.3-9.9 5.6-21.4 2.3-27.2-7.8zm28.3-16.1c-4-7-11.6-9.3-18-5.6-6.4 3.6-8.3 11.4-4.3 18.3 4 7 11.6 9.3 18 5.7 6.4-3.7 8.3-11.4 4.3-18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m294.9 55.4l14.5 36.5-6.2 2.5-12.2-30.8-13.4 5.3 3.3 9.2c5.3 14.6 6.4 23.2-1 26.1-1 0.4-2.2 0.6-3.6 0.8l-1.9-6.1c0.6 0 1-0.1 1.5-0.3 4.2-1.7 3.3-7.6-0.4-18l-5.5-15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m352.8 66.4c2.1 8.6-2.1 14.3-11.1 16.5l-15.3 3.8-9.3-38.2 6.5-1.6 3.1 12.9 9.9-2.4c8.4-2 14.2 0.9 16.2 9zm-6.6 1.7c-1.1-4.8-4.6-6.2-9.7-4.9l-8.4 2 3.5 14.4 8.4-2.1c5.1-1.2 7.4-4.5 6.2-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m391.1 41.5l-18 2.1 4 32.9-6.6 0.8-4.7-39 24.6-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m401.4 54c0-11.6 8.3-20.2 19.7-20.2 11.3 0 19.6 8.5 19.7 20.2 0 11.6-8.4 20.2-19.7 20.2-11.3 0-19.7-8.6-19.7-20.2zm32.5 0c0-8-5.5-13.8-12.8-13.8-7.4 0-12.9 5.8-12.9 13.8 0.1 8 5.5 13.8 12.9 13.8 7.4 0 12.8-5.8 12.8-13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m461.5 36.1l6.6 1-4.1 27.6 23.5-24.7 6.3 0.9-5.8 38.9-6.6-1 4.1-27.6-23.5 24.7-6.3-0.9zm8.3-9.7l4.7 0.7c-0.4 2.8 1 4.5 4 5 3 0.4 4.9-0.8 5.4-3.6l4.7 0.7c-0.8 5.1-4.5 7.6-10.6 6.6-6.3-0.9-9-4.2-8.2-9.4z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m853.2 376.4c4.6 12.3 7.2 25.2 8.1 38.3 0.2 9.7-0.4 19.5 0.5 29.3 0.4 6.5 1.2 13 1.5 19.5 0.3 6.6 0.2 13.1 0 19.6-0.6 13.1-2.7 26.1-6 38.7-0.8 3.2-1.8 6.3-2.8 9.4l-0.6-0.1c0.1-8.1 0.8-16.2 1.3-24.3 0.9-14.3 2.3-29.1 3.3-43.3 0.5-6.5 1.2-13 1.3-19.4 0.2-9.8-1.8-19.4-3.5-28.9-1.1-6.4-1.7-12.8-2.3-19.2-0.6-6.5-1.3-12.9-1.4-19.5 0 0 0.6-0.1 0.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m418 861.9c-12.9 0.9-25.9-0.2-38.5-3-9.3-2.6-18.4-5.9-27.9-7.8-6.3-1.4-12.6-2.4-18.9-3.9-6.3-1.6-12.4-3.5-18.6-5.5-12.2-4.1-24-9.7-35-16.3-2.8-1.7-5.5-3.5-8.1-5.3l0.3-0.6c7.6 2.4 15.1 5.3 22.6 8 13.5 4.8 26.8 10.1 40.2 15.1 8.9 3.5 17.9 7.1 27.3 8.9 6.3 1.3 12.7 1.6 19 2.4 7.9 1 15.7 2.6 23.6 4.1 4.7 1 9.4 2 14 3.3 0.1 0 0 0.6 0 0.6z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m300 828c42.9 18 89.7 29.2 139 31.9 222.6 12.5 412.7-150.2 424.6-363.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m492.2 849c0.2 6.9-4.8 11.2-14.5 11.4l-18.6 0.5-1-39.9 17.4-0.4c8.8-0.3 14.1 3.2 14.3 9.9 0.1 4.2-2 7.3-5.5 9 4.9 1.2 7.7 4.5 7.9 9.5zm-26.5-11.1l9.7-0.3c4.7-0.1 7.1-2.1 7-5.8-0.1-3.8-2.6-5.6-7.3-5.5l-9.8 0.3zm19.2 10.7c-0.1-4-2.8-5.8-7.8-5.6l-11.2 0.3 0.3 11.7 11.2-0.3c5-0.1 7.6-2.2 7.5-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m562 839.5l-19.1 4.2-1.7 9.9-7.3 1.6 8.4-42.8 7-1.5 26 35.1-7.4 1.6zm-3.7-5.1l-11-15.4-3.3 18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m614.5 805c3.1 8.2-1 15.5-10.7 19l-8.3 3.1 4 10.8-6.8 2.5-13.8-37.5 15.1-5.5c9.7-3.6 17.5-0.7 20.5 7.6zm-6.8 2.5c-1.8-4.7-5.8-6.3-11.8-4.1l-8 2.9 5.5 14.9 7.9-3c6-2.2 8.1-6 6.4-10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m649 779.2l-17.3 8.8 15.2 29.9-6.3 3.3-18-35.6 23.6-12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m700.8 778.7l3.4 5.1-24.5 16.2-22-33.3 23.9-15.7 3.4 5.2-17.8 11.7 5.7 8.7 15.8-10.5 3.4 5.1-15.8 10.5 6.1 9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m720.4 718.6l26.3 30-5.5 4.8-11.2-12.9-15.2 13.3 11.2 12.9-5.5 4.8-26.2-30 5.4-4.8 10.9 12.4 15.2-13.3-10.8-12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m756.3 688.4l-8.5 9.7 25.3 22.2-4.7 5.4-25.3-22.2-8.5 9.8-4.8-4.2 21.8-24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m759.7 673.7l4-6 23.6 15.6-12.1-33.2 3.7-5.6 33.3 21.9-3.9 6-23.6-15.6 12.1 33.1-3.7 5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m801.8 597.4l36.4 16.5-3 6.6-15.6-7.1-8.4 18.4 15.6 7.1-3 6.6-36.3-16.5 3-6.6 15 6.8 8.3-18.4-15-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m848.2 561.7l6 1.7-8.1 28.2-38.4-11 7.9-27.5 6 1.8-5.9 20.4 10 2.9 5.2-18.2 5.8 1.7-5.2 18.2 10.6 3z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLogoCropped);
export default __webpack_public_path__ + "static/media/site_logo_cropped.3ce0ac2d82a8023ffebc5b02803060dc.svg";
export { ForwardRef as ReactComponent };